
import Device from "../config/Device.config";
import { useState, useEffect } from "react";
import Confetti from 'react-confetti'
import components from "../tools/components.tool";

const SConfetti = () => {

    const [screen, setScreen] = useState({
        isDesktopDevice: null,
        isMobileDevice: null,
        screenHeight: 0,
        screenWidth: 0,
    });

    const [showConfetti, setShowConfetti] = useState(true);

    useEffect(() => {

        const screen = Device.getDeviceSettings();
        setScreen(screen);
        components.sleep(3).then(() => {
            setShowConfetti(false);
        });

    }, []);

    return (
        <>            
            <Confetti
                width={screen.screenWidth}  // Ancho del área de confeti
                height={screen.screenHeight} // Alto del área de confeti
                numberOfPieces={screen.isDesktopDevice ? 1000 : 400}  // Número de confetis
                recycle={showConfetti}      // Si los confetis deben reciclarse o no
                colors={['#086D4D', '#FFFFFF', '#D0182D']} // Colores de los confetis
                // gravity={0.1}        // Gravedad que afecta a los confetis
                // wind={0.05}           // Viento que afecta a los confetis            
                style={{
                    //zIndex: 99
                    marginRight: "0px",
                    marginLeft: "0px"
                }}
            />
        </>
    )
}

export default SConfetti;